export default __webpack_public_path__ + "static/media/feature5.f8b44040.svg";